import { MultipleChoiceExamEndIllustration } from '../../../../../assets/illustrations';
import { setRecruitingInterviewStep } from '../../../../../store/exam/slice';
import MotionWrapper from '../../../../../containers/MotionWrapper';
import { useDispatch } from '../../../../../store/store';
import Button from '../../../../../components/Button';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.scss';

export default function InterviewEnd() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const navigation = () => {
        dispatch(setRecruitingInterviewStep('KYC'));
        navigate('/workspace');
    };

    return (
        <MotionWrapper className={styles.wrapper}>
            <MultipleChoiceExamEndIllustration />
            <span className={styles.title}>Well done!</span>
            <span className={styles.text}>You finished the interview.</span>
            <Button
                type='Primary'
                onClick={navigation}
                text='Go to dashboard'
                className={styles.navigate}
            />
        </MotionWrapper>
    )
};
